import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector, Field } from 'redux-form';
import { I18n } from 'react-redux-i18n';
import { AreaValidations } from '../../../../models';
import {
  LOCATION_OPTIONS,
} from '../../../../constants/areas';

import Button from '../../../inputs/button/Button';
import AddForm from '../../addform/AddForm';
import FormActions from '../../formactions/FormActions';
import FormField from '../../formfield/FormField';

const loadOption = option => ({
  label: I18n.t(option.label),
  value: option.value
});

export class AreaInfoForm extends Component {
  locationOptions = Object.values(LOCATION_OPTIONS).map(loadOption);
  render() {
    const sites = this.props.sites
      ? this.props.sites.map(site=> ({
          value: site,
          label: site.name
      }))
      : [];
    return (
      <AddForm onSubmit={this.props.handleSubmit}>
        <Field
          name="name"
          label={I18n.t('models.area.name')}
          type="text"
          placeholder={I18n.t('models.area.name')}
          component={FormField}
          maxLength="24"
          validate={AreaValidations.name}
        />
        <Field
          name="site"
          label={I18n.t('models.area.site')}
          type="select"
          component={FormField}
          placeholder={I18n.t('add.area.site')}
          options={sites}
          validate={AreaValidations.site}
        />
        <Field
          name="location"
          label={I18n.t('models.area.areaLocation')}
          type="custom-radio"
          component={FormField}
          options={this.locationOptions}
          validate={AreaValidations.location}
        />
        <FormActions>
          <Button>{I18n.t('add.add')}</Button>
        </FormActions>
      </AddForm>
    );
  }
}

const selector = formValueSelector('addarea');
const mapStateToProps = state => {
  return { location: selector(state, 'location') };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'addarea',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })(AreaInfoForm)
);



// WEBPACK FOOTER //
// ./src/components/forms/addareaform/areainfoform/AreaInfoForm.js